import CheckBoxControl from "../../../../publicComponent/CheckBoxControl";

export default function CheckBox({ className, checked, onClick }) {
  return (
    <CheckBoxControl
      onClick={onClick}
      checked={checked}
      className={`inline-block cursor-pointer rounded-[3px] border-2 border-[#333] mdmax:w-[16px] mdmax:h-[16px] w-[18px] h-[18px] ${checked ? 'bg-[#333]' : 'bg-white'} ${className}`}/>
  );
}
